var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9999 2.66666H11.9333C11.6143 1.11572 10.25 0.002 8.66656 0H7.33322C5.74981 0.002 4.3855 1.11572 4.06656 2.66666H1.99991C1.63172 2.66666 1.33325 2.96513 1.33325 3.33331C1.33325 3.7015 1.63172 4 1.99991 4H2.66656V12.6667C2.66878 14.5067 4.15988 15.9978 5.99991 16H9.99991C11.8399 15.9978 13.331 14.5067 13.3333 12.6667V4H13.9999C14.3681 4 14.6666 3.70153 14.6666 3.33334C14.6666 2.96516 14.3681 2.66666 13.9999 2.66666ZM7.33325 11.3333C7.33325 11.7015 7.03478 12 6.6666 12C6.29838 12 5.99991 11.7015 5.99991 11.3333V7.33334C5.99991 6.96516 6.29838 6.66669 6.66656 6.66669C7.03475 6.66669 7.33322 6.96516 7.33322 7.33334V11.3333H7.33325ZM9.99991 11.3333C9.99991 11.7015 9.70144 12 9.33325 12C8.96506 12 8.6666 11.7015 8.6666 11.3333V7.33334C8.6666 6.96516 8.96506 6.66669 9.33325 6.66669C9.70144 6.66669 9.99991 6.96516 9.99991 7.33334V11.3333ZM5.44725 2.66666C5.73081 1.86819 6.48594 1.33434 7.33325 1.33331H8.6666C9.51391 1.33434 10.269 1.86819 10.5526 2.66666H5.44725Z",
    fill: "#A3A9B6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.2c6fb1c814fdc1a939fa00a44b248b1a.svg";
export { ForwardRef as ReactComponent };